/**
 * User related utility functions
 */

/**
 * Checks if a user or user object has administrative privileges
 * based on role, type, or email.
 * 
 * @param {Object} user - User object from API or Context
 * @returns {Boolean} - True if user is an admin
 */
export const isAdminUser = (user) => {
  if (!user) return false;

  // Normalized values
  const role = (user.role || user.user_type || user.type || '').toLowerCase().trim();
  const email = (user.email || '').toLowerCase().trim();

  // Admin Roles
  const adminRoles = ['admin', 'super_admin', 'system_admin', 'superadmin'];
  
  // Check Role
  if (adminRoles.includes(role)) return true;

  // Check Email (Explicit bypass for system administrator)
  if (email === 'admin@prmanager.com') return true;

  // Check manual type check (legacy/partial data)
  if (user.user_type === 'admin' || user.type === 'admin') return true;

  return false;
};
